import { ReadableStore } from "./ReadableStore";
export class WritableStore extends ReadableStore {
    getReadable() {
        return new ReadableStore(this.value, set => this.subscribe(set));
    }
    set(value) {
        this.updateValue(value);
    }
}
